import { render, staticRenderFns } from "./TopFiveActivity.vue?vue&type=template&id=255c2e32&scoped=true"
import script from "./TopFiveActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./TopFiveActivity.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TopFiveActivity.vue?vue&type=style&index=0&id=255c2e32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c2e32",
  null
  
)

export default component.exports